import { render, staticRenderFns } from "./customText.vue?vue&type=template&id=03278f1a&"
import script from "./customText.vue?vue&type=script&lang=js&"
export * from "./customText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports